import React from "react";
import {useNavigate} from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DonutsCard from "../shelving/sub-components/donutCards";
import {ToScreenSkeleton} from "../screening/sub-components/skeleton";

const ToPicking = ({
                       currentPage, setCurrentPage, allPickingList, isPickingLoading
                   }) => {
    const navigate = useNavigate();
    const handleChangePage = (event) => {
        setCurrentPage((prev) => prev + 1);
    };

    return (<>
            <p className="secondHeader">Picking</p>
            <Row>
                {isPickingLoading ? (
                    <ToScreenSkeleton/>) : allPickingList?.users === undefined || allPickingList?.users === null || allPickingList?.users?.length === 0 || !allPickingList?.users ? (<>
                        <img
                            alt="No data found"
                            src={"no-data.gif"}
                            style={{
                                width: "200px", display: "block", margin: "0 auto", objectFit: "contain",
                            }}
                        />
                    </>) : (<>
                        {allPickingList?.users?.map((user, i) => (<Col
                                xl={4}
                                xxl={4}
                                lg={4}
                                md={6}
                                xs={12}
                                sm={12}
                                key={i}
                                onClick={() => {
                                    navigate("/picking/details-view", {state: user});
                                }}
                                style={{
                                    cursor: "pointer",
                                }}
                            >
                                <DonutsCard
                                    key={i}
                                    left={"Daily Average"}
                                    last={"High Score"}
                                    user={user}
                                />
                            </Col>))}
                    </>)}

                {allPickingList?.users?.length === 0 || (allPickingList?.users?.length !== allPickingList?.totalCount && (
                    <p
                        className="secondHeader"
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={handleChangePage}
                    >
                        Load More
                    </p>
                    ))}
            </Row>
        </>
    );
};

export default ToPicking;